import { ObjectMapper } from './ObjectMapper';
import { resolveDownloadSvg } from '@/utils/resolveBackendUrl';

export class ProductInCategoryMapper {
    // Champs API requis à valider (methods est DÉRIVÉ, pas fourni par l'API → exclu).
    private static propertiesProductInCategory: Array<keyof ProductInCategoryApi> = [
        'id',
        'name',
        'index',
        'previewPath'
    ];

    static getProductFromData(productData: ProductInCategoryApi): ProductInCategory {
        ProductInCategoryMapper.checkProductData(productData);
        const { id, name, index, previewPath, labelList } = productData;

        const product: ProductInCategory = {
            id: id || '',
            name: name || '',
            index: index || 0,
            previewPath: resolveDownloadSvg(previewPath) || '',
            methods: ProductInCategoryMapper.deriveMethods(productData)
        };

        const translatedName: string | undefined = ObjectMapper.getTranslatedName(labelList);
        product.name = translatedName || product.name;

        return product;
    }

    /**
     * Méthodes d'impression disponibles pour la vignette catalogue. Digital est
     * TOUJOURS présent et en tête (profil implicite, cf. store availablePrintProfiles) ;
     * on ajoute ensuite les méthodes non-digital, dédupliquées. Source privilégiée :
     * `printMethods` (strings résolues par le grouped endpoint) ; repli sur les objets
     * `printProfiles` (autres endpoints qui les résolvent en entités).
     */
    private static deriveMethods(data: ProductInCategoryApi): string[] {
        const methods = ['digital'];
        const add = (m?: string) => {
            if (m && m !== 'digital' && !methods.includes(m)) {
                methods.push(m);
            }
        };
        (data.printMethods ?? []).forEach((m) => add(m));
        (data.printProfiles ?? []).forEach((p) => add(p?.method));
        return methods;
    }

    private static checkProductData(productData: ProductInCategoryApi): void {
        ProductInCategoryMapper.propertiesProductInCategory.forEach((prop) => {
            if (productData[prop] == null) {
                console.error(`Property ${prop} is missing or undefined in this product: ${productData.id}.`);
            }
        });
    }
}
